import { createContext, useContext } from 'react';
export const defaultPanelContext = {
  inPanel: false,
  inModal: false
};
export const PanelContext = /*#__PURE__*/createContext(defaultPanelContext);
export function usePanelContext() {
  return useContext(PanelContext);
}
export const {
  Consumer,
  Provider
} = PanelContext;